/**
 * AUTO-GENERATED FILE — DO NOT EDIT MANUALLY
 *
 * Generated by: tools/scripts/generate-tools-registry.ts
 * Source: tools/tool-definitions/*.tool.ts
 *
 * To regenerate: npx ts-node tools/scripts/generate-tools-registry.ts
 */

import { IToolData } from './types';
import {
  ALL_TOOLS as LEGACY_ALL_TOOLS,
  TOOLS_BY_CATEGORY as LEGACY_TOOLS_BY_CATEGORY,
} from './tools';
// No new framework-based tools yet
const NEW_TOOLS: IToolData[] = [];

/** All tools: legacy (from tools.tsx) + new (from tool-definitions/) */
export const ALL_TOOLS: IToolData[] = [...LEGACY_ALL_TOOLS, ...NEW_TOOLS];

/** Tools grouped by category, merging legacy and new */
export const TOOLS_BY_CATEGORY: Record<string, IToolData[]> = (() => {
  // Start with cloned legacy categories so adding new tools does not mutate tools.tsx exports.
  const merged: Record<string, IToolData[]> = {};

  for (const [category, tools] of Object.entries(LEGACY_TOOLS_BY_CATEGORY)) {
    merged[category] = [...tools];
  }

  // Add new tools to their categories
  for (const tool of NEW_TOOLS) {
    for (const cat of tool.categories || []) {
      if (!merged[cat]) {
        merged[cat] = [];
      }
      merged[cat].push(tool);
    }
  }

  return merged;
})();

/** Look up a tool by its ID */
export function getToolById(id: string): IToolData | undefined {
  return ALL_TOOLS.find((t) => t.id === id);
}

/** All new framework-based tool definitions */
export { NEW_TOOLS };
